import { hubBaseUrl } from '@shared/lib/auditLogger';
import { isKiosk } from '@shared/lib/constants';
import { getAuthToken } from './authToken';

export type EventType =
  | 'started_task'
  | 'task_completed'
  | 'dispatched_robot'
  | 'started_driving'
  | 'e_stop_pressed';

export type EventExtraInfo =
  | { type: 'started_task'; tray_count?: number; object_count?: number }
  | { type: 'task_completed'; cycle_time_seconds: number; task_id?: string | null }
  | {
      type: 'dispatched_robot';
      destination: string;
      travel_time_seconds?: number | null;
      distance_meters?: number | null;
    }
  | { type: 'started_driving' }
  | { type: 'e_stop_pressed'; e_stop_type: 'electronic' | 'physical' };

export interface EventRobot { id: number; name: string; org_id: number }
export interface EventUser { id: number; email: string }

export interface EventLogEntry {
  id: number;
  created_at: string;
  event_type: EventType;
  robot_id: number;
  user_id: number | null;
  extra_info: EventExtraInfo;
  robot: EventRobot;
  user: EventUser | null;
}

export async function fetchEvents(args: {
  orgId: number;
  robotId?: number | null;
  start?: Date;
  end?: Date;
}): Promise<EventLogEntry[]> {
  const token = getAuthToken();
  if (!token && !isKiosk) throw new Error('Not authenticated');
  const params = new URLSearchParams({ org_id: String(args.orgId) });
  if (args.robotId != null) params.set('robot_id', String(args.robotId));
  if (args.start) params.set('start', args.start.toISOString());
  if (args.end) params.set('end', args.end.toISOString());
  const headers: Record<string, string> = {};
  if (token) headers.Authorization = `Bearer ${token}`;
  const r = await fetch(`${hubBaseUrl()}/events?${params}`, { headers });
  if (!r.ok) throw new Error(`Failed to fetch events (${r.status})`);
  return r.json();
}
